import { PolicyType } from "../PrivacyPolicy/PrivacyPolicType";

export type getPolicyByIdType = {
  getPolicyById: PolicyType;
};

export const selectStyles = {
  control: (base, state) => ({
    ...base,
    backgroundColor: "var(--amplify-colors-brand-primary-100)",
    color: "var(--amplify-colors-text-onDark)",
    borderColor: state.selectProps.isInvalid
      ? "red"
      : state.isFocused
        ? "var(--amplify-colors-brand-primary-40)"
        : "var(--amplify-colors-border-primary)",
    boxShadow: state.selectProps.isInvalid
      ? "0 0 0 3px red"
      : state.isFocused
        ? "0 0 0 3px var(--amplify-colors-link-focus)"
        : "none",
    borderRadius: 1,
    minHeight: 48,
    marginLeft: -15,
    paddingLeft: 2,
    ":hover": {
      borderColor: state.selectProps.isInvalid
        ? "red"
        : state.isFocused
          ? "var(--amplify-colors-brand-primary-40)"
          : "var(--amplify-colors-border-primary)",
    },
  }),
  placeholder: (base) => ({
    ...base,
    color: "var(--amplify-colors-placeholder)",
  }),
  singleValue: (base) => ({
    ...base,
    color: "var(--amplify-colors-text-onDark)",
  }),
  input: (base) => ({ ...base, color: "var(--amplify-colors-text-onDark)" }),
  dropdownIndicator: (base, state) => ({
    ...base,
    color: state.isFocused
      ? "var(--amplify-colors-text-onDark)"
      : "var(--amplify-colors-muted)",
    ":hover": { color: "var(--amplify-colors-text-onDark)" },
  }),
  indicatorSeparator: () => ({ display: "none" }),
  menu: (base) => ({
    ...base,
    backgroundColor: "var(--amplify-colors-brand-primary-40)",
    border: "1px solid var(--amplify-colors-border-primary)",
    boxShadow: "0 8px 20px rgba(0,0,0,.18)",
    overflow: "hidden",
    marginLeft: -15,
  }),
  menuList: (base) => ({ ...base, padding: 6 }),
  option: (base, state) => ({
    ...base,
    backgroundColor: state.isSelected
      ? "var(--amplify-colors-brand-primary-40)"
      : state.isFocused
        ? "var(--amplify-colors-brand-primary-10)"
        : "transparent",
    color: "var(--amplify-colors-text-onDark)",
    ":active": {
      backgroundColor: state.isSelected
        ? "var(--amplify-colors-brand-primary-40)"
        : "var(--amplify-colors-brand-primary-10)",
    },
  }),
  clearIndicator: (base) => ({
    ...base,
    color: "var(--amplify-colors-muted)",
    ":hover": { color: "var(--amplify-colors-text-onDark)" },
  }),
};
